import type { LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Label({
  className,
  ...rest
}: LabelHTMLAttributes<HTMLLabelElement>): JSX.Element {
  return (
    <label
      className={cn(
        'text-xs font-bold uppercase tracking-wide text-fg-muted',
        className,
      )}
      {...rest}
    />
  );
}
